/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

const BlankMain = (): React.Node => <section />;

export default compose(React.memo)(BlankMain);
